(function () {
	const multicolumnSlider = () => {
		const multicolumnSliders = Array.from(
			document.querySelectorAll(".multicolumn-slider")
		);
		if (multicolumnSliders.length === 0) return;
		multicolumnSliders.forEach((slider) => {
			if (slider.dataset.initialized) return;
			slider.dataset.initialized = "true";

			const sectionId = slider.dataset.id;
			const perRow = slider.dataset.perRow;
			const mobileR = parseInt(slider.dataset.mobile, 10) || 2;
			const speed = slider.dataset.speed * 1000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const enablenNavigation = toBoolean(slider.dataset.navigation);
			const stopAutoplaySlider = toBoolean(slider.dataset.stopAutoplay);
			const gapDesktop = parseInt(slider.dataset.gapDesktop, 10) || 0;
			const gapMobile = parseInt(slider.dataset.gapMobile, 10) || 0;
			const useAutoWidth = toBoolean(slider.dataset.autoSlides);

			const swiperEl = document.querySelector(`#${sectionId} .swiper`);
			if (!swiperEl) return;
			const swiperWrapperEl = swiperEl.querySelector(".swiper-wrapper");

			if (autoplay) {
				const originalSlides = Array.from(
					swiperEl.querySelectorAll(".swiper-slide")
				);
				originalSlides.forEach((slide) => {
					swiperWrapperEl.appendChild(slide.cloneNode(true));
				});

				new Swiper(`#${sectionId} .swiper`, {
					loop: false,
					slidesPerView: useAutoWidth ? "auto" : mobileR,
					spaceBetween: gapMobile,
					allowTouchMove: false,
					speed: speed,
					breakpoints: {
						1100: {
							slidesPerView: useAutoWidth ? "auto" : +perRow + 0.4,
							spaceBetween: gapDesktop,
						},
					},
				});

				const applyMarquee = () => {
					const slideW = originalSlides[0]?.getBoundingClientRect().width;
					if (!slideW) return;
					const gap = window.innerWidth >= 1100 ? gapDesktop : gapMobile;
					const setWidth = originalSlides.length * (slideW + gap);
					const duration = (originalSlides.length * speed) / 1000;

					swiperWrapperEl.style.setProperty("--marquee-width", `${setWidth}px`);
					swiperWrapperEl.style.setProperty("--marquee-duration", `${duration}s`);
					swiperWrapperEl.classList.add("multicolumn-marquee");
				};

				if (stopAutoplaySlider) {
					slider.addEventListener("mouseenter", () => {
						swiperWrapperEl.style.animationPlayState = "paused";
					});
					slider.addEventListener("mouseleave", () => {
						swiperWrapperEl.style.animationPlayState = "running";
					});
				}

				const resizeObserver = new ResizeObserver((entries) => {
					for (const entry of entries) {
						if (entry.contentRect.width > 0) applyMarquee();
					}
				});
				resizeObserver.observe(swiperEl);
				slider._resizeObserver = resizeObserver;

				return;
			}

			const multicolumnSwiper = new Swiper(`#${sectionId} .swiper`, {
				loop: true,
				longSwipesRatio: 0.1,
				slidesPerView: useAutoWidth ? "auto" : mobileR,
				spaceBetween: gapMobile,
				allowTouchMove: true,
				grabCursor: true,
				speed: speed,
				breakpoints: {
					1100: {
						slidesPerView: useAutoWidth ? "auto" : +perRow + 0.4,
						spaceBetween: gapDesktop,
					},
				},
			});

			if (enablenNavigation) {
				const cursor = document.getElementById(`${sectionId}-cursor`);

				const animateCursor = (e) => {
					const x = e.clientX - cursor.offsetWidth / 2,
						y = e.clientY - cursor.offsetHeight / 2;
					cursor.animate(
						{ transform: `translate(${x}px, ${y}px)` },
						{ duration: 100, fill: "forwards" }
					);
				};

				const getCursorClass = (type) => {
					switch (type) {
						case "next":
							return "cursor-icon next button button--simple";
						case "prev":
							return "cursor-icon prev button button--simple";
						default:
							return "cursor-icon button button--simple";
					}
				};

				document.querySelector(
					`#${sectionId} .multicolumn-cursor`
				).onmousemove = (e) => {
					const interactable = e.target.closest(".multicolumn__buttons"),
						interacting = interactable !== null;
					const icon = document.getElementById(`${sectionId}-cursor-icon`);
					if (interactable != null) animateCursor(e);
					cursor.dataset.type = interacting ? interactable.dataset.type : "";
					if (interacting) icon.className = getCursorClass(interactable.dataset.type);
				};

				document
					.querySelector(`#${sectionId} .multicolumn-button-next`)
					.addEventListener("click", () => {
						multicolumnSwiper.slideNext(1000);
					});

				document
					.querySelector(`#${sectionId} .multicolumn-button-prev`)
					.addEventListener("click", () => {
						multicolumnSwiper.slidePrev(1000);
					});
			}
		});
	};

	const dragScroll = () => {
		const scrollWrappers = Array.from(
			document.querySelectorAll(".multicolumn-list__wrapper--scroll")
		);
		if (scrollWrappers.length === 0) return;
		scrollWrappers.forEach((el) => {
			if (el.dataset.dragBound) return;
			el.dataset.dragBound = "true";
			let isDown = false;
			let hasDragged = false;
			let startX;
			let scrollLeft;
			el.addEventListener("mousedown", (e) => {
				isDown = true;
				hasDragged = false;
				startX = e.pageX - el.offsetLeft;
				scrollLeft = el.scrollLeft;
				el.classList.add("is-dragging");
			});
			el.addEventListener("dragstart", (e) => {
				e.preventDefault();
			});
			el.addEventListener("mouseleave", () => {
				isDown = false;
				el.classList.remove("is-dragging");
			});
			el.addEventListener("mouseup", () => {
				isDown = false;
				el.classList.remove("is-dragging");
			});
			el.addEventListener("mousemove", (e) => {
				if (!isDown) return;
				const dx = e.pageX - el.offsetLeft - startX;
				if (Math.abs(dx) > 4) hasDragged = true;
				el.scrollLeft = scrollLeft - dx;
			});
			// prevent link navigation if the pointer moved during drag
			el.addEventListener("click", (e) => {
				if (hasDragged) e.preventDefault();
			}, true);
		});
	};

	function toBoolean(string) {
		return string === "true" ? true : false;
	}

	function detectDeviceType() {
		if (isiPad()) {
			const multicolumnLists = document.querySelectorAll(".multicolumn-list");
			multicolumnLists.forEach((elem) => {
				if (elem) {
					elem.classList.add("multicolumn-list__ipad");
				}
			});
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		multicolumnSlider();
		detectDeviceType();
		dragScroll();
		document.addEventListener("shopify:section:load", function () {
			multicolumnSlider();
			detectDeviceType();
			dragScroll();
		});
		document.addEventListener("shopify:section:unload", (event) => {
			const slider = event.target.querySelector(".multicolumn-slider");
			if (!slider) return;
			if (slider._resizeObserver) {
				slider._resizeObserver.disconnect();
				delete slider._resizeObserver;
			}
			const wrapperEl = slider.querySelector(".swiper-wrapper");
			if (wrapperEl) wrapperEl.classList.remove("multicolumn-marquee");
			delete slider.dataset.initialized;
		});
	});
})();
